import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AngularFireList, AngularFireDatabase } from 'angularfire2/database';
import { BehaviorSubject } from 'rxjs';
import { Contact } from 'src/app/models/contact.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContactService {
  private url=environment.firebaseConfig.databaseURL;
  contactList:AngularFireList<any>;
  private contacts:Contact[]=[];
  newContacts:Contact[]=[];
  contactsChange=new BehaviorSubject<Contact[]>([]);
  constructor(private http:HttpClient, private firebase:AngularFireDatabase) { }

  getContactslList(){
    this.contactList=this.firebase.list('contacts');  
  }
  fetchContacts(){
    this.http.get<Contact[]>(environment.firebaseConfig.databaseURL+'/contacts.json').subscribe(res=>{
      this.setContacts(res);
    },error=>{
      console.log(error);
    });
  }

  setContacts(contact:Contact[]){
    this.contacts=contact;
    this.newContacts=Object.keys(this.contacts).map(key=>({$key:key,...this.contacts[key]}));
    this.contactsChange.next(this.newContacts.reverse());
    // console.log(this.newContacts);
  }

  updateContact(contact:any,$key:string){
    this.getContactslList();
    this.contactList.update($key,contact).catch(error=>{
      alert(error.message);
      return false;
    });
    return true;
  }
  setContact(contact:Contact){
    this.contacts.push(contact);
    this.http.post<Contact[]>(this.url+'/contacts.json',contact).subscribe(
      res=>{
        alert("We have received your message, we will contact you soon. Thank You!");
      },error=>{
        alert("Something Wrong Happen. Please Try Again!");
      }
    );
  }
}
